import {createElement, Component, PropTypes} from 'rlink-react';
import StringInput from './StringInput';

export default class PasswordInput extends StringInput {
  normalizeValue (value) {
     // password should always be taken literally, including whitespace
    return value ? value : '';
  }
  get inputType () {
    return 'password';
  }
}




// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/PasswordInput.jsx